<template>
  <v-dialog
    v-model="dialog"
    max-width="1320px"
    max-height="800px"
    width="unset"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        rounded
        color="primary"
        v-bind="$attrs"
        class="text-none text-white"
        :style="styleButton"
        v-on="on"
        @click="reset"
      >
        <v-icon
          dark
          left
        >
          mdi-application-import
        </v-icon>
        {{ mensagemBotao }}
      </v-btn>
    </template>
    <v-card
      justify="center"
      align="center"
    >
      <v-toolbar
        color="primary"
        dark
      >
        <v-col
          cols="11.5"
        >
          <span class="headline">{{ dialogTitle }}</span>
        </v-col>
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <v-card-text>
          <div
            class="d-flex justify-end pb-2"
          >
            <v-col cols="12">
              <span>
                Após clicar em "<span style="font-weight: bold;">Importar PDF</span>", o mesmo será importada e os dados serão inseridos no sistema!<br>
                Se ocorrer alguma inconsistência, será retornado os dados incorretos.
              </span>
            </v-col>
          </div>
          <base-file-drop
            ref="file-drop"
            width="800px"
            accept=".pdf"
            @files-selected="handleFiles"
          >
            <v-card
              v-if="pdf === null"
              outlined
              class="pb-10 pt-6 d-flex flex-column align-center justify-space-around"
              height="250px"
            >
              <v-btn
                icon
                color="primary"
                elevation="0"
                x-large
                @click="selectFiles"
              >
                <v-icon x-large>
                  mdi-file-upload
                </v-icon>
              </v-btn>

              <span> <b>Escolha</b> um arquivo do disco</span>
              <span> ou </span>
              <span> <b>arraste</b> um arquivo para cá </span>
            </v-card>
            <v-card
              v-else
              class="d-flex flex-column align-center justify-space-around"
              outlined
              height="250px"
            >
              <v-container class="mb-auto">
                <v-row>
                  <v-col cols="auto">
                    <span style="font-size: 18px; text-align: center; display: inline-block; padding-top: 9px; padding-left: 5px; padding-right: 5px;">Arquivo selecionado:</span>
                  </v-col>
                  <v-col cols="auto">
                    <span style="font-size: 18px; text-align: center; display: inline-block; padding-top: 5px; padding-left: 5px; padding-right: 5px; background-color: #e0e0e0; border-radius: 10px;">
                      <v-icon
                        color="red"
                        style="padding-bottom: 5px;"
                      >
                        mdi-file-pdf-box
                      </v-icon>
                      {{ pdf.name }}
                      <v-icon
                        color="error"
                        style="padding-bottom: 5px;"
                        @click="pdf = null"
                      >
                        mdi-close-circle-outline
                      </v-icon>
                    </span>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="pa-0"
                  />
                </v-row>
              </v-container>
            </v-card>
          </base-file-drop>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="text-none text-white mx-1"
            color="error"
            rounded
            @click="dialog = false"
          >
            <v-icon
              dark
              left
            >
              mdi-minus-circle
            </v-icon>
            Cancelar
          </v-btn>
          <div
            v-if="!loading && pdf !== null"
          >
            <v-btn
              class="text-none nx-1 text-white mx-1"
              color="warning"
              rounded
              @click="clearTable()"
            >
              <v-icon>
                mdi-broom
              </v-icon>
              Limpar Arquivo
            </v-btn>
          </div>
          <v-btn
            class="text-none text-white mx-1"
            :disabled="pdf === null"
            color="success"
            rounded
            @click="submit"
          >
            <v-icon
              dark
              left
            >
              mdi-checkbox-marked-circle
            </v-icon>
            Importar
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
  import Swal from 'sweetalert2'

  export default {
    name: 'ImportPdf',
    props: {
      styleButton: {
        type: String,
        default: 'margin: 2px',
      },
      dialogTitle: {
        type: String,
        default: 'Upload de Arquivos',
      },
      methodoSend: {
        type: Function,
        required: true,
      },
      mensagemBotao: {
        type: String,
        default: 'Importar',
      },
    },
    data () {
      return {
        dialog: false,
        loading: true,
        pdf: null,
        message: 'Carregando...',
      }
    },
    methods: {
      reset () {
        this.pdf = null
      },
      clearTable () {
        this.loading = true
        this.pdf = null
      },
      submit () {
        if (this.pdf === null) {
          return window.Toast.fire({
            icon: 'error',
            title: 'Selecione um arquivo para importação',
          })
        }
        Swal.fire({
          title: 'Importando PDF!',
          icon: 'info',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          confirmButtonColor: '#109010',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          focusConfirm: false,
          preConfirm: () => {
            return this.methodoSend(this.pdf).then(result => {
              this.dialog = false
              this.pdf = null
              Swal.fire(
                'Atenção!',
                'Os dados foram importados com sucesso!',
                'success',
              )
            }).catch(error => {
              console.error(error)
              Swal.hideLoading()
              Swal.fire({
                icon: 'error',
                title: 'Erro ao importar os dados!',
                text: error.message,
              })
            })
          },
        })
      },
      selectFiles () {
        this.loading = false
        this.$refs['file-drop'].activate()
      },
      handleFiles (files) {
        const file = files[0]
        if (file.type !== 'application/pdf') {
          return window.Toast.fire({
            icon: 'error',
            title: 'Arquivo inválido para importação',
          })
        }
        this.pdf = file
      },
    },
  }
</script>
